/**
* @license Apache-2.0
*
* Copyright (c) 2022 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name assert
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/complex/base/assert}
*/
import assert from './../../base/assert';
setReadOnly( ns, 'assert', assert );

/**
* @name cast
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/base/cast-return}
*/
import cast from './../../base/cast-return';
setReadOnly( ns, 'cast', cast );

/**
* @name parse
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/base/parse}
*/
import parse from './../../base/parse';
setReadOnly( ns, 'parse', parse );

/**
* @name wrap
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/complex/base/wrap-function}
*/
import wrap from './../../base/wrap-function';
setReadOnly( ns, 'wrap', wrap );


// EXPORTS //

export default ns;
